module.exports = __webpack_public_path__ + "img/华工大国际校区图书馆.3a56132c.png";